import { faLayerGroup } from "@fortawesome/free-solid-svg-icons";
import { PageConfigs } from "configs/globalInterfaces";

const name = "projectCategories";

export const CONFIGS: PageConfigs = {
  title: name,
  path: `/${name}`,
  icon: faLayerGroup,
  apiName: `${name}`,
  routeName: name,
  apiAddress: `${"project-categories"}`,
  componentNames: ["projectCategory", "projectCategories"],
  permissions: [`read:${name}`, `maintain:${name}`],
  routes: {
    all: `/${name}/*`,
    base: `/${name}`,
    list: "/list",
    add: `/add`,
    edit: `/edit/:id`,
  },
};
